import React, { useEffect, useState, useRef } from "react"
import Skeleton from "react-loading-skeleton"
import Api from "@/_helpers/Api"
import { trans } from "@/_providers/Translation"
import { LineChart } from "@mui/x-charts"
import moment from "moment"
import { Button } from "@mui/material"
import CompactFilterLayout from "@/components/partials/CompactFilterLayout"
import DateRange from "@/components/partials/DateRange"
import filterImage from "@/assets/img/icons/filter.svg"
import ChartInfo from "./ChartInfo"
import Dropdown from "@/components/partials/Dropdown"

const INITIAL_FILTERS = {
  customer_id: "",
  date_from: null,
  date_to: null,
  type: "",
  // customer_name: "",
}

function formatAxisValue(value) {
  const abs = Math.abs(value)
  if (abs >= 1e9) return `${+(value / 1e9).toFixed(1)}B`
  if (abs >= 1e6) return `${+(value / 1e6).toFixed(1)}M`
  if (abs >= 1e3) return `${+(value / 1e3).toFixed(1)}k`
  return String(value)
}

function CLVForecast() {
  const [loading, setLoading] = useState(true)
  const [labels, setLabels] = useState([])
  const [historical, setHistorical] = useState([])
  const [predicted, setPredicted] = useState([])
  const [customers, setCustomers] = useState([])
  const [filters, setFilters] = useState(INITIAL_FILTERS)

  const compactFilterLayoutRef = useRef(null)
  const fetchDebounceRef = useRef(null)

  useEffect(() => {
    clearTimeout(fetchDebounceRef.current)
    fetchDebounceRef.current = setTimeout(() => {
      loadData()
    }, 300)
    return () => clearTimeout(fetchDebounceRef.current)
  }, [filters])

  function loadData() {
    setLoading(true)

    const f = `?type=${filters.type || ""}${filters.customer_id ? `&customer_id=${filters.customer_id}` : ""}${filters.date_from ? `&date_from=${filters.date_from || ""}` : ""}${filters.date_to ? `&date_to=${filters.date_to || ""}` : ""}`
    Api.get(`analytics/predicted-clv${f}`)
      .then((res) => {
        setLabels(
          res.data.chart_data.labels?.map((date) => {
            return moment(date, "YYYY-MM").isSame(moment(), "month")
              ? trans("analytics.today")
              : moment(date, "YYYY-MM").format("MM.YYYY")
          }) || [],
        )
        setHistorical(res.data.chart_data.historical || [])
        setPredicted(res.data.chart_data.predicted || [])
        setCustomers(res.data.customers || [])

        setLoading(false)
      })
      .catch(() => setLoading(false))
  }

  const historicalSeries = labels.map((_, i) =>
    i < historical.length ? (historical[i] ?? null) : null,
  )

  const boundaryIndex = historical.length - 1
  const predictedSeries = labels.map((_, i) => {
    if (i === boundaryIndex) return historical[boundaryIndex] ?? null
    if (i > boundaryIndex) return predicted[i - historical.length] ?? null
    return null
  })

  function hasAnyData() {
    return labels.length > 0
  }

  function handleFilterChange(name, value) {
    setFilters((prev) => ({ ...prev, [name]: value }))
  }

  function getAppliedFiltersCount() {
    let count = 0
    if (filters.customer_id) count++
    if (filters.date_from || filters.date_to) count++
    return count
  }

  return (
    <div className="customers-chart">
      <div className="head">
        <h3>
          {trans("analytics.clvForecast")}
          <ChartInfo name="predictedClv" />
        </h3>
        <div className="right">
          <Button
            onClick={(e) => {
              compactFilterLayoutRef.current.open(e)
            }}
          >
            <img src={filterImage} alt="Filter" />
            {getAppliedFiltersCount() ? (
              <i>{getAppliedFiltersCount()}</i>
            ) : (
              <></>
            )}
          </Button>
          <CompactFilterLayout
            ref={compactFilterLayoutRef}
            appliedFiltersCount={getAppliedFiltersCount()}
            onClearClick={() => setFilters(INITIAL_FILTERS)}
          >
            <div className="row">
              <div className="col">
                <DateRange
                  startDate={filters.date_from || ""}
                  endDate={filters.date_to || ""}
                  onStartDateChange={(date) =>
                    handleFilterChange("date_from", date)
                  }
                  onEndDateChange={(date) =>
                    handleFilterChange("date_to", date)
                  }
                  monthOnly
                />
              </div>
            </div>
            <div className="row">
              <div className="col">
                <select
                  value={filters.type || ""}
                  name="type"
                  onChange={(e) => {
                    handleFilterChange("type", e.target.value)
                    handleFilterChange("customer_id", "")
                  }}
                >
                  <option value="">{trans("random.allTypes")}</option>
                  <option value="customer">{trans("random.client")}</option>
                  <option value="company">{trans("random.company")}</option>
                  <option value="subscription">
                    {trans("random.subscription")}
                  </option>
                  <option value="warranty">{trans("random.warranty")}</option>
                </select>
              </div>
            </div>
            <div className="row">
              <div className="col">
                {loading ? (
                  <Skeleton height={40} width={140} count={1} />
                ) : (
                  <Dropdown
                    inputName=""
                    // inputValue={popup.data?.customer_id || ""}
                    inputIdName="customer_id"
                    inputIdValue={filters?.customer_id || ""}
                    // url="partners/categories/all"
                    // params={{
                    //   id: popup.data?.appliancecategory?.id || null,
                    // }}
                    // inputClassName={
                    //   validations && validations.appliance_category_id
                    //     ? "validate"
                    //     : ""
                    // }
                    filter
                    data={customers}
                    onChange={(data) => {
                      handleFilterChange("customer_id", data.id)
                    }}
                    inputPlaceholder={trans("random.allCustomers")}
                  />

                  // <select
                  //   value={filters.customer_id || ""}
                  //   name="customer_id"
                  //   onChange={(e) =>
                  //     handleFilterChange("customer_id", e.target.value)
                  //   }
                  // >
                  //   <option value="">{trans("random.allCustomers")}</option>
                  //   {customers.map((customer) => (
                  //     <option key={customer.id} value={customer.id}>
                  //       {customer.name}
                  //     </option>
                  //   ))}
                  // </select>
                )}
              </div>
            </div>
            {/* <div className="row">
              <div className="col">
                <input
                  type="text"
                  placeholder={`${trans("random.clientName")}...`}
                  value={filters.customer_name || ""}
                  onChange={(e) =>
                    handleFilterChange("customer_name", e.target.value)
                  }
                />
              </div>
            </div> */}
          </CompactFilterLayout>
        </div>
      </div>
      <hr />
      {loading ? (
        <Skeleton height={300} count={1} />
      ) : !hasAnyData() ? (
        <div
          className="alert warning"
          style={{
            marginBottom: 0,
            width: "100%",
          }}
        >
          {trans("messages.noDataFound")}
        </div>
      ) : (
        <LineChart
          xAxis={[{ scaleType: "point", data: labels }]}
          yAxis={[{ valueFormatter: formatAxisValue }]}
          series={[
            {
              label: trans("analytics.historicalData"),
              area: true,
              data: historicalSeries,
              color: "#9ba9dd",
              valueFormatter: (v) => (v == null ? "" : String(v)),
            },
            {
              label: trans("analytics.forecast"),
              data: predictedSeries,
              area: true,
              color: "#bec6e1",
              valueFormatter: (v) => (v == null ? "" : String(v)),
            },
          ]}
          height={295}
          sx={{
            "& .MuiLineElement-root": { strokeWidth: 1 },
          }}
          slotProps={{
            legend: { hidden: true },
          }}
        />
      )}
    </div>
  )
}

export default CLVForecast
